import Typography from "@mui/material/Typography";
import { FC } from "react";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import { EyeOnIcon } from "shared/theme/icons/EyeOnIcon";
import { StyledAuthBadge } from "./styled";

type AuthBadgeProps = {
  title: string;
};

const AuthBadge: FC<AuthBadgeProps> = ({ title }) => {
  return (
    <StyledAuthBadge>
      <FlexCenter>
        <EyeOnIcon />
      </FlexCenter>
      <Typography variant="bodySMedium">{title}</Typography>
    </StyledAuthBadge>
  );
};

export default AuthBadge;
